<template>
    <div class="edit">
        <div v-for="template in montageTemplateList" :key="template._id">
            <retail-title :main-title="template.templateName"></retail-title>
            <div class="form-wrapper">
                <render-container
                    :schema="schemaObject[template._id]"
                    :formData="formData"
                    :formRulesProps="formRules"
                    :ref="`template_${template._id}`"
                ></render-container>
            </div>
        </div>
        <div class="btns-wrapper">
            <el-button @click="submit" type="primary" :loading="loading">
                提交审核
            </el-button>
        </div>
    </div>
</template>

<script>
import { v1 as uuid } from 'uuid'
import { parseJSONString } from './../../common/utils'
import editMixins from './../../common/mixins/editMixins'
import getMixins from '../../common/mixins/getMixins'
import transformTitle from './../../common/transform/transformTitle'

export default {
    name: 'add',
    data() {
        return {
            businessParams: null,
            loading: false
        }
    },
    created() {
        console.log('add', '=============================')
        // generate uuid
        this.uuid = uuid()
        // get params from query
        const {
            channelNo,
            departId,
            // projectId,
            departName,
            projectName,
            projectId
        } = this.$route.query
        // save variables
        this.channelNo = channelNo
        this.departId = departId
        this.departName = departName
        this.projectName = projectName
        this.projectId = projectId
        this.businessParams = { channelNo, departId, projectId }
        // get montage model object
        this.$apiServe.computerSettleIn
            .getShopMontage({
                channelNo,
                departId,
                uuid: this.uuid,
                projectId
            })
            .then(res => {
                // --------添加字段联动属性-------
                // 给关联根字段添加 rule 联动属性
                let relationData = this.addRelation(res, businessParams)
                res.marketTemplateConfigInfo.templateDetailList =
                    relationData.templateDetailList
                // ---------------
                res.marketTemplateConfigInfo.templateDetailList = transformTitle(
                    res
                )
                const businessParams = { departId }
                // 获取排序的模版
                this.montageTemplateList = this.getMontageTemplateList(res)
                // 如果有保存的数据，数据需回填
                this.formData = this.getFormData(this.montageTemplateList, res)
                // 生成每个模版的schema
                this.schemaObject = this.getSchemaObject(
                    this.montageTemplateList,
                    this.formData,
                    businessParams
                )
                this.formRules = this.getFormRules(
                    this.montageTemplateList,
                    businessParams
                )
            })
    },
    methods: {
        submit() {
            this.loading = true
            // 获取容器中的elForm getFormInstace
            const formInstanceList = this.montageTemplateList.map(({ _id }) =>
                this.getFormInstace(this.$refs[`template_${_id}`][0])
            )
            Promise.all(
                formInstanceList.map(
                    (formInstance, index) =>
                        new Promise((resolve, reject) => {
                            // 当前表单信息
                            const currentFormFieldList = this.montageTemplateList[
                                index
                            ].templateFieldParamList.map(field => ({
                                ...field,
                                configSetting: parseJSONString(
                                    field.configSetting,
                                    {}
                                )
                            }))
                            // 联动表单校验 formcreat 组件的校验结果
                            let FCValid = this.FormCreatValidate(
                                this.formData,
                                currentFormFieldList
                            )
                            formInstance.validate(valid => {
                                valid && FCValid
                                    ? resolve(currentFormFieldList)
                                    : reject(valid)
                            })
                        })
                )
            )
                .then(currentFormFieldList => {
                    const currentFormData = this.addRelationFieldValue(
                        this.formData,
                        currentFormFieldList.flat()
                    )
                    this.$apiServe.computerSettleIn
                        .saveShopForm({
                            data: currentFormData,
                            channelNo: this.channelNo,
                            finished: true,
                            uuid: this.uuid,
                            departId: this.departId,
                            projectId: this.projectId,
                            // 当前页面表单 字段
                            fieldList: Object.keys(currentFormData)
                        })
                        .then(() => {
                            this.$alert('正审信息已提交，待审核', '提示', {
                                confirmButtonText: '返回',
                                showClose: false,
                                type: 'success',
                                callback: () => {
                                    const {
                                        channelNo,
                                        departId,
                                        departName,
                                        projectName,
                                        projectId
                                    } = this
                                    const query = {
                                        channelNo,
                                        departId,
                                        departName,
                                        projectName,
                                        projectId
                                    }
                                    this.$router.push({
                                        name: 'detailShopComputerSettleIn',
                                        query
                                    })
                                }
                            })
                        })
                        .finally(() => {
                            this.loading = false
                        })
                })
                // false
                .catch(err => {
                    console.log(err)
                    this.loading = false
                })
        }
    },
    mixins: [editMixins, getMixins]
}
</script>

<style lang="scss" scoped>
.form-wrapper {
    width: 460px;
    margin: 0 auto;
}
.btns-wrapper {
    width: 460px;
    margin: 0 auto;
    text-align: center;
}
</style>
